<template>
  <div id="player-general-performance-table">
    <v-data-table
      :headers="tableHeaders"
      :loading="loading"
      :items="playerPerformance"
      hide-default-footer
      dense
      disable-pagination
      :custom-sort="customSort"
      sort-by="last_name"
      :sort-desc="true"
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-no-wrap">
            {{ item.last_name }}, {{ item.first_name }}
          </td>
          <td
            v-for="tableHeader in tableHeaders.slice(1)"
            :key="tableHeader.id"
          >
            <table-bar-value
              :value="getValue(item, getVariableName(tableHeader.value))"
              :max="colorsMaxValues[getVariableName(tableHeader.value)]"
              :color="tableHeader.colorable ? getColorFromValue(getValue(item, getVariableName(tableHeader.value)), colorsMaxValues[getVariableName(tableHeader.value)], tableHeader.reverse) : 'grey lighten-2'"
            >
              {{ getValue(item, getVariableName(tableHeader.value)) }} {{ getVariableUnit() }}
            </table-bar-value>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import TableBarValue from '@/components/helpers/TableBarValue'
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'PerformanceWeeklyTable',
  components: { TableBarValue },
  props: {
    playerPerformance: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    maxValues: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'total'
    },
    tableHeaders: {
      type: Array,
      required: true
    },
    colorsMaxValues: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  methods: {
    getColorFromValue(value, max, log) {
      return getColorForValue(value, max)
    },
    getVariableName(variable) {
      let insert = ''

      if (this.type === 'games') insert = '_G'
      else if (this.type === 'games60') insert = '_G_60'

      return variable + insert + '_7'
    },
    getVariableUnit(variable = '') {
      if (this.type === 'total') return ''

      return '%'
    },
    getValue(player, variable) {
      return player.latest_stats[variable]
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        let aValue = null
        let bValue = null

        if (index[0] === 'last_name') {
          aValue = a.last_name
          bValue = b.last_name
        } else {
          let insert = ''

          if (this.type === 'games') insert = '_G'
          else if (this.type === 'games60') insert = '_G_60'

          aValue = a.latest_stats[index + insert + '_7']
          bValue = b.latest_stats[index + insert + '_7']
        }

        if (isDesc[0]) {
          if (aValue === null || aValue === undefined) return -1
          if (bValue === null || bValue === undefined) return 1
          return aValue > bValue ? 1 : -1
        } else {
          if (aValue === null || aValue === undefined) return 1
          if (bValue === null || bValue === undefined) return -1
          return aValue < bValue ? 1 : -1
        }
      })
      return items
    }
  }
}
</script>
